<template>
  <div
    class="app-sidebar"
    ref="sidebar"
    :class="{
      'app-sidebar_collapsed': collapsed,
    }"
  >
    <div
      class="app-sidebar__overlay"
      :class="{
        'app-sidebar__overlay_hidden': !activeMenuItem,
      }"
      @click="activeMenuItem = null"
    ></div>

    <div class="app-sidebar__wrapper" :class="{ 'app-sidebar__wrapper_collapsed': collapsed }">
      <div class="app-sidebar__header">
        <div
          class="app-sidebar__user"
          :class="{ 'app-sidebar__user_active': activeMenuItem === 'user' }"
          @click="(e) => selectMenuItem(e, 'user')"
        >
          <div
            v-if="user.avatar"
            class="app-sidebar__user-avatar"
            :style="{ backgroundImage: `url(${user.avatar})` }"
          ></div>

          <div v-if="!user.avatar" class="app-sidebar__user-avatar-placeholder">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="17" cy="17" r="17" fill="#8E9CBB" />

              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="34" height="34">
                <circle cx="17" cy="17" r="17" fill="#8E9CBB" />
              </mask>

              <g mask="url(#mask0)">
                <path
                  d="M28 30L26 31.5V26.5926C26 25.905 25.7103 25.2456 25.1945 24.7594C24.6788 24.2731 23.9793 24 23.25 24H17H10.75C10.0207 24 9.32118 24.2731 8.80546 24.7594C8.28973 25.2456 8 25.905 8 26.5926V31.5L6 30V26.6667C6 25.429 6.50044 24.242 7.39124 23.3668C8.28204 22.4917 9.49022 22 10.75 22C10.75 22 15 22 17 22C19 22 23.25 22 23.25 22C24.5098 22 25.718 22.4917 26.6088 23.3668C27.4996 24.242 28 25.429 28 26.6667V30Z"
                  fill="#333333"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M23 14C23 17.3137 20.3137 20 17 20C13.6863 20 11 17.3137 11 14C11 10.6863 13.6863 8 17 8C20.3137 8 23 10.6863 23 14ZM21 14C21 16.2091 19.2091 18 17 18C14.7909 18 13 16.2091 13 14C13 11.7909 14.7909 10 17 10C19.2091 10 21 11.7909 21 14Z"
                  fill="#333333"
                />
              </g>
            </svg>
          </div>

          <div class="app-sidebar__user-name">
            {{ user.name }}
          </div>
        </div>

        <div
          class="app-sidebar__notifications"
          :style="{
            cursor: notifications.list.length === 0 ? 'initial' : 'pointer',
          }"
          :class="{
            'app-sidebar__notifications__active': activeMenuItem === 'notifications',
          }"
          @click="(e) => selectMenuItem(e, 'notifications')"
        >
          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.3333 7.88475C14.3333 6.2975 13.7714 4.77525 12.7712 3.6529C11.771 2.53054 10.4145 1.90001 9 1.90001C7.58551 1.90001 6.22896 2.53054 5.22876 3.6529C4.22857 4.77525 3.66667 6.2975 3.66667 7.88475C3.66667 14.8669 1 15.8999 1 15.8999H17C17 15.8999 14.3333 14.8669 14.3333 7.88475Z"
              stroke="#8E9CBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11 19C10.7968 19.3031 10.505 19.5547 10.154 19.7295C9.80302 19.9044 9.40506 19.9965 9 19.9965C8.59494 19.9965 8.19698 19.9044 7.84598 19.7295C7.49498 19.5547 7.20325 19.3031 7 19"
              stroke="#8E9CBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div v-if="notifications.count > 0" class="app-sidebar__notifications-count">
            {{ notifications.count }}
          </div>
        </div>
      </div>

      <div class="app-sidebar__menu">
        <div
          class="app-sidebar__menu-item app-sidebar__menu-item_calculations"
          :class="{
            'app-sidebar__menu-item_active': activeMenuItem === 'calculations',
          }"
          @click="(e) => selectMenuItem(e, 'calculations')"
        >
          <div class="app-sidebar__menu-item-icon">
            <svg width="18" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 7H17M4 11H6M4 15H6M8 11H10M8 15H10M13 16V10M3 19H15C16.1046 19 17 18.1046 17 17V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19Z"
                stroke-width="2"
              />
            </svg>
          </div>

          <div class="app-sidebar__menu-item-label">Расчеты</div>
        </div>

        <div
          class="app-sidebar__menu-item app-sidebar__menu-item_employees"
          :class="{
            'app-sidebar__menu-item_active': activeMenuItem === 'employees',
          }"
          @click="(e) => selectMenuItem(e, 'employees')"
        >
          <div class="app-sidebar__menu-item-icon">
            <svg width="18" height="22" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 20C13 20.5523 13.4477 21 14 21C14.5523 21 15 20.5523 15 20H13ZM11.5 16V15V16ZM6.5 16V15V16ZM4 18.6667H3H4ZM3 20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20H3ZM8 5C8 5.55228 8.44772 6 9 6C9.55229 6 10 5.55228 10 5H8ZM10 1C10 0.447715 9.55229 0 9 0C8.44772 0 8 0.447715 8 1H10ZM15 20V18.6667H13V20H15ZM15 18.6667C15 17.7143 14.6459 16.789 13.9973 16.0971L12.5382 17.465C12.8273 17.7733 13 18.2046 13 18.6667H15ZM13.9973 16.0971C13.3466 15.4031 12.4498 15 11.5 15V17C11.8762 17 12.2512 17.1588 12.5382 17.465L13.9973 16.0971ZM11.5 15H6.5V17H11.5V15ZM6.5 15C5.55015 15 4.65335 15.4031 4.0027 16.0971L5.46177 17.465C5.74879 17.1588 6.12376 17 6.5 17V15ZM4.0027 16.0971C3.35409 16.789 3 17.7143 3 18.6667H5C5 18.2046 5.1727 17.7733 5.46177 17.465L4.0027 16.0971ZM3 18.6667V20H5V18.6667H3ZM10 11C10 11.5523 9.55228 12 9 12V14C10.6569 14 12 12.6569 12 11H10ZM9 12C8.44772 12 8 11.5523 8 11H6C6 12.6569 7.34315 14 9 14V12ZM8 11C8 10.4477 8.44772 10 9 10V8C7.34315 8 6 9.34315 6 11H8ZM9 10C9.55229 10 10 10.4477 10 11H12C12 9.34315 10.6569 8 9 8V10ZM2 18V6H0V18H2ZM4 4H14V2H4V4ZM16 6V18H18V6H16ZM14 20H4V22H14V20ZM16 18C16 19.1046 15.1046 20 14 20V22C16.2091 22 18 20.2091 18 18H16ZM14 4C15.1046 4 16 4.89543 16 6H18C18 3.79086 16.2091 2 14 2V4ZM2 6C2 4.89543 2.89543 4 4 4V2C1.79086 2 0 3.79086 0 6H2ZM0 18C0 20.2091 1.79086 22 4 22V20C2.89543 20 2 19.1046 2 18H0ZM10 5V1H8V5H10Z"
              />
            </svg>
          </div>

          <div class="app-sidebar__menu-item-label">Кадры</div>
        </div>

        <div
          class="app-sidebar__menu-item app-sidebar__menu-item_reports"
          :class="{
            'app-sidebar__menu-item_active': activeMenuItem === 'reports',
          }"
          @click="(e) => selectMenuItem(e, 'reports')"
        >
          <div class="app-sidebar__menu-item-icon">
            <svg width="20" height="16" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1H2ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14V16ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM6 9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9H6ZM8 11C8 11.5523 8.44772 12 9 12C9.55229 12 10 11.5523 10 11H8ZM10 5C10 4.44772 9.55229 4 9 4C8.44772 4 8 4.44772 8 5H10ZM16 11C16 11.5523 16.4477 12 17 12C17.5523 12 18 11.5523 18 11H16ZM18 3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3H18ZM12 11C12 11.5523 12.4477 12 13 12C13.5523 12 14 11.5523 14 11H12ZM14 7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7H14ZM0 1V15H2V1H0ZM1 16H19V14H1V16ZM6 11V9H4V11H6ZM10 11V5H8V11H10ZM18 11V3H16V11H18ZM14 11V7H12V11H14Z"
              />
            </svg>
          </div>

          <div class="app-sidebar__menu-item-label">Отчеты</div>
        </div>

        <!--<div
          class="app-sidebar__menu-item app-sidebar__menu-item_marketing"
          :class="{
            'app-sidebar__menu-item_active': activeMenuItem === 'marketing',
          }"
          @click="(e) => selectMenuItem(e, 'marketing')"
        >
          <div class="app-sidebar__menu-item-icon">
            <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 5V6.00002L10.0062 5.99998L10 5ZM19.0315 1.03125L20.0315 1.03613C20.0335 0.632225 19.7923 0.266789 19.4201 0.109836C19.0479 -0.047117 18.6179 0.0352329 18.33 0.318574L19.0315 1.03125ZM19 17.0625L18.2984 17.7751C18.5857 18.0579 19.0145 18.1406 19.3863 17.9849C19.7581 17.8292 20 17.4655 20 17.0625L19 17.0625ZM9.00009 13V12C8.67169 12 8.36423 12.1612 8.1775 12.4314L9.00009 13ZM9 20L9.00391 21C9.36983 20.9986 9.70575 20.7974 9.87974 20.4755C10.0537 20.1535 10.038 19.7623 9.83869 19.4554L9 20ZM5 20.0156L4.15478 20.55C4.33879 20.8411 4.65959 21.017 5.00391 21.0156L5 20.0156ZM5 13L5.84842 13.5293C6.04152 13.2198 6.05075 12.8297 5.87252 12.5114C5.69428 12.1931 5.35685 11.9971 4.99206 12L5 13ZM3.03151 13.0156L3.02358 12.0157C2.996 12.0159 2.96844 12.0172 2.94098 12.0197L3.03151 13.0156ZM2.00026 12.0156H3.00026V12.0156L2.00026 12.0156ZM2.00018 6L3.00018 5.99999C3.00017 5.9483 2.99617 5.89669 2.98819 5.84562L2.00018 6ZM12 5C12 4.44772 11.5523 4 11 4C10.4477 4 10 4.44772 10 5H12ZM10 13.0625C10 13.6148 10.4477 14.0625 11 14.0625C11.5523 14.0625 12 13.6148 12 13.0625H10ZM19.4142 10.4142C19.0237 10.8047 19.0237 11.4379 19.4142 11.8284C19.8047 12.219 20.4379 12.219 20.8284 11.8284L19.4142 10.4142ZM20.8284 6.17157C20.4379 5.78105 19.8047 5.78105 19.4142 6.17157C19.0237 6.5621 19.0237 7.19526 19.4142 7.58579L20.8284 6.17157ZM3.00018 6H10V4H3.00018V6ZM10 5C10.0062 5.99998 10.0066 5.99998 10.007 5.99998C10.0072 5.99997 10.0076 5.99997 10.008 5.99997C10.0086 5.99996 10.0094 5.99996 10.0102 5.99995C10.0118 5.99993 10.0138 5.99991 10.016 5.99989C10.0205 5.99983 10.0262 5.99975 10.0331 5.99962C10.047 5.99936 10.0656 5.99893 10.0889 5.99819C10.1355 5.99673 10.2006 5.99407 10.2827 5.98924C10.4468 5.9796 10.6794 5.96126 10.9684 5.92639C11.5457 5.85674 12.352 5.72062 13.2892 5.45403C15.161 4.92162 17.5826 3.86055 19.733 1.74393L18.33 0.318574C16.4801 2.13945 14.386 3.06275 12.7421 3.53034C11.9214 3.76376 11.2199 3.88154 10.7288 3.94079C10.4837 3.97038 10.2919 3.98525 10.1653 3.99269C10.1021 3.99641 10.0551 3.99827 10.026 3.99918C10.0115 3.99964 10.0014 3.99986 9.99596 3.99996C9.99325 4.00001 9.99169 4.00003 9.99132 4.00004C9.99113 4.00004 9.99125 4.00004 9.99166 4.00004C9.99186 4.00003 9.99214 4.00003 9.9925 4.00003C9.99267 4.00003 9.993 4.00002 9.99309 4.00002C9.99343 4.00002 9.99379 4.00002 10 5ZM18.0315 1.02637C18.0001 7.4664 17.9998 10.9684 18 17.0625L20 17.0625C19.9998 10.9691 20.0001 7.4711 20.0315 1.03613L18.0315 1.02637ZM19.7016 16.3499C17.6607 14.3407 16.163 13.2087 14.6596 12.6132C13.1464 12.0139 11.7196 12 10 12V14C11.7554 14 12.813 14.033 13.9232 14.4727C15.0433 14.9163 16.3081 15.8156 18.2984 17.7751L19.7016 16.3499ZM10 12H9.00009V14H10V12ZM9.00009 13C8.1775 12.4314 8.17722 12.4318 8.17693 12.4322C8.17682 12.4323 8.17653 12.4328 8.17631 12.4331C8.17588 12.4337 8.17542 12.4344 8.17492 12.4351C8.17391 12.4366 8.17277 12.4383 8.17149 12.4401C8.16892 12.4439 8.16579 12.4485 8.16214 12.454C8.15484 12.4649 8.14542 12.4792 8.1341 12.4967C8.11148 12.5318 8.08123 12.5799 8.04515 12.6404C7.97307 12.7613 7.87721 12.9321 7.77223 13.1467C7.56308 13.5742 7.31292 14.1849 7.14565 14.9264C6.80834 16.4217 6.8093 18.4625 8.16131 20.5446L9.83869 19.4554C8.84695 17.9281 8.84795 16.4689 9.09663 15.3665C9.22235 14.8092 9.41166 14.3467 9.56874 14.0257C9.64687 13.866 9.71581 13.7437 9.76275 13.665C9.78619 13.6258 9.804 13.5976 9.81457 13.5812C9.81985 13.573 9.8233 13.5678 9.82473 13.5657C9.82544 13.5646 9.82564 13.5643 9.82531 13.5648C9.82514 13.565 9.82484 13.5655 9.82441 13.5661C9.82419 13.5664 9.82393 13.5668 9.82365 13.5672C9.8235 13.5674 9.82326 13.5678 9.82319 13.5679C9.82294 13.5683 9.82268 13.5686 9.00009 13ZM8.99609 19L4.99609 19.0156L5.00391 21.0156L9.00391 21L8.99609 19ZM5.84522 19.4812C4.92111 18.0197 4.91355 16.5505 5.1527 15.4056C5.27266 14.8313 5.45331 14.3498 5.6033 14.0139C5.67793 13.8467 5.74391 13.718 5.78911 13.6345C5.81167 13.5928 5.82893 13.5626 5.83936 13.5447C5.84457 13.5358 5.84807 13.53 5.84964 13.5274C5.85043 13.5261 5.85074 13.5256 5.85054 13.5259C5.85045 13.5261 5.85022 13.5264 5.84987 13.527C5.84969 13.5273 5.84948 13.5276 5.84924 13.528C5.84912 13.5282 5.84892 13.5285 5.84886 13.5286C5.84864 13.529 5.84842 13.5293 5 13C4.15158 12.4707 4.15134 12.4711 4.15109 12.4715C4.151 12.4716 4.15074 12.472 4.15055 12.4723C4.15018 12.4729 4.14977 12.4736 4.14933 12.4743C4.14844 12.4757 4.14742 12.4774 4.14628 12.4792C4.14398 12.483 4.14116 12.4876 4.13785 12.4931C4.13122 12.5041 4.12261 12.5185 4.11223 12.5363C4.09146 12.5718 4.06355 12.6209 4.03017 12.6826C3.96348 12.8058 3.87455 12.9802 3.77707 13.1985C3.58282 13.6336 3.35038 14.2526 3.19496 14.9967C2.88332 16.4886 2.87577 18.5272 4.15478 20.55L5.84522 19.4812ZM4.99206 12L3.02358 12.0157L3.03945 14.0156L5.00794 14L4.99206 12ZM2.94098 12.0197C2.94922 12.019 2.95048 12.0194 2.94626 12.0192C2.9424 12.019 2.93752 12.0184 2.93286 12.0174C2.92826 12.0164 2.92668 12.0156 2.92811 12.0162C2.92968 12.0169 2.9359 12.0195 2.94516 12.0257C2.95476 12.0322 2.96655 12.0418 2.97829 12.0548C2.9903 12.0681 2.99891 12.0813 3.00429 12.0919C3.00958 12.1023 3.009 12.1047 3.00684 12.095C3.00457 12.0847 3.00026 12.0595 3.00026 12.0156H1.00026C1.00026 12.7575 1.31491 13.3395 1.8288 13.6852C2.28048 13.989 2.78352 14.0423 3.12205 14.0115L2.94098 12.0197ZM3.00026 12.0156L3.00018 5.99999L1.00018 6.00002L1.00026 12.0156L3.00026 12.0156ZM2.98819 5.84562C2.99147 5.86663 2.98991 5.87263 2.98955 5.87465C2.98881 5.87892 2.98416 5.90262 2.96214 5.93518C2.95075 5.95202 2.93632 5.9687 2.91946 5.98335C2.90244 5.99814 2.88758 6.00683 2.8788 6.01104C2.86035 6.01989 2.88862 6 3.00018 6V4C2.26977 4 1.66552 4.28229 1.3054 4.81482C0.987124 5.28547 0.958208 5.80907 1.01216 6.15438L2.98819 5.84562ZM10 5V13.0625H12V5H10ZM20.8284 11.8284C21.1999 11.457 21.4945 11.016 21.6955 10.5307L19.8478 9.76537C19.7472 10.008 19.5999 10.2285 19.4142 10.4142L20.8284 11.8284ZM21.6955 10.5307C21.8965 10.0454 22 9.52529 22 9H20C20 9.26264 19.9483 9.52272 19.8478 9.76537L21.6955 10.5307ZM22 9C22 8.47471 21.8965 7.95457 21.6955 7.46927L19.8478 8.23463C19.9483 8.47728 20 8.73736 20 9H22ZM21.6955 7.46927C21.4945 6.98396 21.1999 6.54301 20.8284 6.17157L19.4142 7.58579C19.5999 7.7715 19.7472 7.99198 19.8478 8.23463L21.6955 7.46927Z"
              />
            </svg>
          </div>

          <div class="app-sidebar__menu-item-label">Маркетинг</div>
        </div>-->

        <div
          class="app-sidebar__menu-item app-sidebar__menu-item_reference"
          :class="{
            'app-sidebar__menu-item_active': activeMenuItem === 'references',
          }"
          @click="(e) => selectMenuItem(e, 'references')"
        >
          <div class="app-sidebar__menu-item-icon">
            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 17V3C1 1.89543 1.89543 1 3 1H16V19H3C1.89543 19 1 18.1046 1 17ZM1 17C1 15.8954 1.89543 15 3 15H16M4 6H13M16 4H19M16 8H19M16 12H19M5 9H12"
                stroke="#8E9CBB"
                stroke-width="2"
              />
            </svg>
          </div>

          <div class="app-sidebar__menu-item-label">Справочники</div>
        </div>

        <div
          class="app-sidebar__menu-item app-sidebar__menu-item_all_sections"
          :class="{
            'app-sidebar__menu-item_active': activeMenuItem === 'allSections',
          }"
          @click="(e) => selectMenuItem(e, 'allSections')"
        >
          <div class="app-sidebar__menu-item-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
              width="20px"
              height="22px"
            >
              <path
                d="M492,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,236,492,236z"
              />
              <path
                d="M492,76H20C8.954,76,0,84.954,0,96s8.954,20,20,20h472c11.046,0,20-8.954,20-20S503.046,76,492,76z"
              />
              <path
                d="M492,396H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h472c11.046,0,20-8.954,20-20
C512,404.954,503.046,396,492,396z"
              />
            </svg>
          </div>

          <div class="app-sidebar__menu-item-label">Все разделы</div>
        </div>

        <!--      <div class="app-sidebar__menu-item app-sidebar__menu-item_bookmarks"-->
        <!--        @click="e => selectMenuItem(e, 'bookmarks')"-->
        <!--        :class="{'app-sidebar__menu-item_active': activeMenuItem === 'bookmarks'}"-->
        <!--      >-->
        <!--        <div class="app-sidebar__menu-item-icon">-->
        <!--          <svg width="18" height="21" viewBox="0 0 18 21" xmlns="http://www.w3.org/2000/svg">-->
        <!--            <path d="M17 20L9 15.4444L1 20V3.22222C1 2.63285 1.24082 2.06762 1.66947 1.65087C2.09812 1.23413 2.67951 1 3.28571 1H14.7143C15.3205 1 15.9019 1.23413 16.3305 1.65087C16.7592 2.06762 17 2.63285 17 3.22222V20Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
        <!--            <path d="M9 4.4375L10.236 6.9415L13 7.3455L11 9.2935L11.472 12.0455L9 10.7455L6.528 12.0455L7 9.2935L5 7.3455L7.764 6.9415L9 4.4375Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
        <!--          </svg>-->
        <!--        </div>-->

        <!--        <div class="app-sidebar__menu-item-label">Закладки</div>-->
        <!--      </div>-->

        <div class="app-sidebar__menu-item app-sidebar__menu-item_mobile-menu">
          <div
            class="app-sidebar__menu-item-icon"
            :class="{ 'app-sidebar__menu-item-icon_active': !mobileMenuActive }"
            @click="(e) => openMobileMenu(e)"
          >
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1H17M1 8H17M1 15H17"
                stroke="#8E9CBB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div
            class="app-sidebar__menu-item-icon"
            :class="{ 'app-sidebar__menu-item-icon_active': mobileMenuActive }"
            @click="mobileMenuActive = false"
          >
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.0254 15.0007L2.02468 1M1.9541 15.0007L15.9548 1"
                stroke="#FF238D"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="app-sidebar__settings">
        <a
          class="app-sidebar__settings-item app-sidebar__settings-item_settings"
          :href="getMenuItemHref({ routeName: 'tables-settings' })"
          @click="onSidebarMenuLinkClick($event, { routeName: 'tables-settings' })"
        >
          <div class="app-sidebar__settings-item-icon">
            <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 13.7273C12.5062 13.7273 13.7273 12.5062 13.7273 11C13.7273 9.49377 12.5062 8.27273 11 8.27273C9.49377 8.27273 8.27273 9.49377 8.27273 11C8.27273 12.5062 9.49377 13.7273 11 13.7273Z"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.7273 13.7273C17.6063 14.0015 17.5702 14.3056 17.6236 14.6005C17.6771 14.8954 17.8177 15.1676 18.0273 15.3818L18.0818 15.4364C18.2509 15.6052 18.385 15.8057 18.4765 16.0265C18.568 16.2472 18.6151 16.4838 18.6151 16.7227C18.6151 16.9617 18.568 17.1983 18.4765 17.419C18.385 17.6397 18.2509 17.8402 18.0818 18.0091C17.913 18.1781 17.7124 18.3122 17.4917 18.4037C17.271 18.4952 17.0344 18.5423 16.7955 18.5423C16.5565 18.5423 16.3199 18.4952 16.0992 18.4037C15.8785 18.3122 15.678 18.1781 15.5091 18.0091L15.4545 17.9545C15.2403 17.745 14.9682 17.6044 14.6733 17.5509C14.3784 17.4974 14.0742 17.5335 13.8 17.6545C13.5311 17.7698 13.3018 17.9611 13.1403 18.205C12.9788 18.4489 12.8921 18.7347 12.8909 19.0273V19.1818C12.8909 19.664 12.6994 20.1265 12.3584 20.4675C12.0174 20.8084 11.5549 21 11.0727 21C10.5905 21 10.1281 20.8084 9.78708 20.4675C9.4461 20.1265 9.25455 19.664 9.25455 19.1818V19.1C9.24751 18.7991 9.15011 18.5073 8.97501 18.2625C8.79991 18.0176 8.55521 17.8312 8.27273 17.7273C7.99853 17.6063 7.69437 17.5702 7.39947 17.6236C7.10456 17.6771 6.83244 17.8177 6.61818 18.0273L6.56364 18.0818C6.39478 18.2509 6.19425 18.385 5.97353 18.4765C5.7528 18.568 5.51621 18.6151 5.27727 18.6151C5.03834 18.6151 4.80174 18.568 4.58102 18.4765C4.36029 18.385 4.15977 18.2509 3.99091 18.0818C3.82186 17.913 3.68775 17.7124 3.59626 17.4917C3.50476 17.271 3.45766 17.0344 3.45766 16.7955C3.45766 16.5565 3.50476 16.3199 3.59626 16.0992C3.68775 15.8785 3.82186 15.678 3.99091 15.5091L4.04545 15.4545C4.25503 15.2403 4.39562 14.9682 4.4491 14.6733C4.50257 14.3784 4.46647 14.0742 4.34545 13.8C4.23022 13.5311 4.03887 13.3018 3.79497 13.1403C3.55107 12.9788 3.26526 12.8921 2.97273 12.8909H2.81818C2.33597 12.8909 1.87351 12.6994 1.53253 12.3584C1.19156 12.0174 1 11.5549 1 11.0727C1 10.5905 1.19156 10.1281 1.53253 9.78708C1.87351 9.4461 2.33597 9.25455 2.81818 9.25455H2.9C3.2009 9.24751 3.49273 9.15011 3.73754 8.97501C3.98236 8.79991 4.16883 8.55521 4.27273 8.27273C4.39374 7.99853 4.42984 7.69437 4.37637 7.39947C4.3229 7.10456 4.18231 6.83244 3.97273 6.61818L3.91818 6.56364C3.74913 6.39478 3.61503 6.19425 3.52353 5.97353C3.43203 5.7528 3.38493 5.51621 3.38493 5.27727C3.38493 5.03834 3.43203 4.80174 3.52353 4.58102C3.61503 4.36029 3.74913 4.15977 3.91818 3.99091C4.08704 3.82186 4.28757 3.68775 4.50829 3.59626C4.72901 3.50476 4.96561 3.45766 5.20455 3.45766C5.44348 3.45766 5.68008 3.50476 5.9008 3.59626C6.12152 3.68775 6.32205 3.82186 6.49091 3.99091L6.54545 4.04545C6.75971 4.25503 7.03183 4.39562 7.32674 4.4491C7.62164 4.50257 7.9258 4.46647 8.2 4.34545H8.27273C8.54161 4.23022 8.77093 4.03887 8.93245 3.79497C9.09397 3.55107 9.18065 3.26526 9.18182 2.97273V2.81818C9.18182 2.33597 9.37338 1.87351 9.71435 1.53253C10.0553 1.19156 10.5178 1 11 1C11.4822 1 11.9447 1.19156 12.2856 1.53253C12.6266 1.87351 12.8182 2.33597 12.8182 2.81818V2.9C12.8193 3.19253 12.906 3.47834 13.0676 3.72224C13.2291 3.96614 13.4584 4.15749 13.7273 4.27273C14.0015 4.39374 14.3056 4.42984 14.6005 4.37637C14.8954 4.3229 15.1676 4.18231 15.3818 3.97273L15.4364 3.91818C15.6052 3.74913 15.8057 3.61503 16.0265 3.52353C16.2472 3.43203 16.4838 3.38493 16.7227 3.38493C16.9617 3.38493 17.1983 3.43203 17.419 3.52353C17.6397 3.61503 17.8402 3.74913 18.0091 3.91818C18.1781 4.08704 18.3122 4.28757 18.4037 4.50829C18.4952 4.72901 18.5423 4.96561 18.5423 5.20455C18.5423 5.44348 18.4952 5.68008 18.4037 5.9008C18.3122 6.12152 18.1781 6.32205 18.0091 6.49091L17.9545 6.54545C17.745 6.75971 17.6044 7.03183 17.5509 7.32674C17.4974 7.62164 17.5335 7.9258 17.6545 8.2V8.27273C17.7698 8.54161 17.9611 8.77093 18.205 8.93245C18.4489 9.09397 18.7347 9.18065 19.0273 9.18182H19.1818C19.664 9.18182 20.1265 9.37338 20.4675 9.71435C20.8084 10.0553 21 10.5178 21 11C21 11.4822 20.8084 11.9447 20.4675 12.2856C20.1265 12.6266 19.664 12.8182 19.1818 12.8182H19.1C18.8075 12.8193 18.5217 12.906 18.2778 13.0676C18.0339 13.2291 17.8425 13.4584 17.7273 13.7273Z"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </a>

        <div
          class="app-sidebar__settings-item app-sidebar__settings-item_help"
          :class="{
            'app-sidebar__settings-item_active': activeMenuItem === 'help',
          }"
          @click="(e) => selectMenuItem(e, 'help')"
        >
          <div class="app-sidebar__settings-item-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM13.446 7.968C13.1017 7.38474 12.6153 6.89826 12.032 6.554L15.657 2.929L17.071 4.343L13.446 7.968ZM7.968 13.446L4.343 17.071L2.929 15.657L6.554 12.032C6.89826 12.6153 7.38474 13.1017 7.968 13.446ZM7.968 6.554C7.38474 6.89826 6.89826 7.38474 6.554 7.968L2.929 4.343L4.343 2.93L7.968 6.555V6.554ZM12.704 12.948C11.9332 13.655 10.9162 14.032 9.87079 13.9981C8.82541 13.9643 7.83488 13.5223 7.11142 12.767C6.38797 12.0116 5.98916 11.0029 6.00044 9.95706C6.01172 8.9112 6.4322 7.91136 7.17178 7.17178C7.91136 6.4322 8.9112 6.01172 9.95706 6.00044C11.0029 5.98916 12.0116 6.38797 12.767 7.11142C13.5223 7.83488 13.9643 8.82541 13.9981 9.87079C14.032 10.9162 13.655 11.9332 12.948 12.704C13.141 12.494 13.307 12.269 13.446 12.032L16.32 14.906C15.9093 15.4343 15.4343 15.9093 14.906 16.32L12.032 13.446C12.269 13.306 12.494 13.141 12.704 12.948ZM10 12C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10C12 9.46957 11.7893 8.96086 11.4142 8.58579C11.0391 8.21071 10.5304 8 10 8C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10C8 10.5304 8.21071 11.0391 8.58579 11.4142C8.96086 11.7893 9.46957 12 10 12Z"
              />
            </svg>
          </div>
        </div>

        <div
          class="app-sidebar__collapse"
          :class="{ 'app-sidebar__collapse_collapsed': collapsed }"
          @click="toggleCollapse"
        >
          <div class="app-sidebar__collapse-icon">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
                fill="#8E9CBB"
              />
              <path
                d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
                fill="#8E9CBB"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div
      v-for="(section, sectionName) in menuItemsLocal"
      :key="sectionName"
      class="app-sidebar__submenu"
      :class="{
        'app-sidebar__submenu_active': sectionName === activeMenuItem && activeMenuItem !== 'allSections',
        'app-sidebar__submenu_all_sections': sectionName === 'allSections',
        'app-sidebar__submenu_all_sections_active': activeMenuItem === 'allSections' && sectionName === 'allSections',
      }"
    >
      <div class="app-sidebar__submenu-search">
        <c-input v-model="search" placeholder="Поиск" icon="search" placeholder-style="italic" clearable />
      </div>

      <div v-if="activeMenuItem !== 'allSections'" class="app-sidebar__submenu-list">
        <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]">
          <a
            :key="`${itemIndex}-route`"
            class="app-sidebar__submenu-list-item"
            :class="{
              'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
            }"
            :href="getMenuItemHref(item)"
            :target="isExternalMenuItem(item) ? '_blank' : null"
            :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
            @click="onSidebarMenuLinkClick($event, item)"
          >
            {{ item.label }}
          </a>
        </template>
      </div>

      <div v-if="activeMenuItem === 'allSections'" class="app-sidebar__submenu-list-all-sections">
        <div class="app-sidebar__submenu-list-all-sections-column">
          <div
            v-if="menuItemsLocal[sectionName]['Отчеты'] && menuItemsLocal[sectionName]['Отчеты'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">ОТЧЁТЫ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Отчеты']">
              <a
                :key="`${itemIndex}-reports-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Кадры'] && menuItemsLocal[sectionName]['Кадры'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">КАДРЫ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Кадры']">
              <a
                :key="`${itemIndex}-employee-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
        </div>
        <div class="app-sidebar__submenu-list-all-sections-column">
          <div
            v-if="menuItemsLocal[sectionName]['Пользователи'] && menuItemsLocal[sectionName]['Пользователи'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">ПОЛЬЗОВАТЕЛИ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Пользователи']">
              <a
                :key="`${itemIndex}-users-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Графики'] && menuItemsLocal[sectionName]['Графики'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">ГРАФИКИ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Графики']">
              <a
                :key="`${itemIndex}-charts-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Листовки'] && menuItemsLocal[sectionName]['Листовки'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">ЛИСТОВКИ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Листовки']">
              <a
                :key="`${itemIndex}-papers-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Маркетинг'] && menuItemsLocal[sectionName]['Маркетинг'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">МАРКЕТИНГ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Маркетинг']">
              <a
                :key="`${itemIndex}-marketing-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Настройки'] && menuItemsLocal[sectionName]['Настройки'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">НАСТРОЙКИ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Настройки']">
              <a
                :key="`${itemIndex}-settings-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Расчеты'] && menuItemsLocal[sectionName]['Расчеты'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">РАСЧЕТЫ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Расчеты']">
              <a
                :key="`${itemIndex}-calculations-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
          <div
            v-if="menuItemsLocal[sectionName]['Справочники'] && menuItemsLocal[sectionName]['Справочники'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <div class="app-sidebar__submenu-list-all-sections-column-item-title">СПРАВОЧНИКИ</div>
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Справочники']">
              <a
                :key="`${itemIndex}-reference-route`"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
        </div>
        <div class="app-sidebar__submenu-list-all-sections-column">
          <div
            v-if="menuItemsLocal[sectionName]['Остальные'] && menuItemsLocal[sectionName]['Остальные'].length > 0"
            class="app-sidebar__submenu-list-all-sections-column-item"
          >
            <template v-for="(item, itemIndex) in menuItemsLocal[sectionName]['Остальные']">
              <a
                :key="`${itemIndex}-other-route`"
                class="app-sidebar__submenu-list-all-sections-column-item-title app-sidebar__submenu-list-all-sections-column-item-title-hover"
                style="cursor: pointer"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div
      class="app-sidebar__submenu app-sidebar__submenu_user"
      :class="{ 'app-sidebar__submenu_active': activeMenuItem === 'user' }"
    >
      <!--    <div class="app-sidebar__submenu-list">-->
      <!--      <div class="app-sidebar__submenu-list-item">Профиль</div>-->
      <!--      <div class="app-sidebar__submenu-list-item">Жалобы и предложения</div>-->
      <!--      <div class="app-sidebar__submenu-list-item">Инструкции</div>-->
      <!--      <div class="app-sidebar__submenu-list-item">Календарь событий</div>-->
      <!--    </div>-->

      <!--    <div class="app-sidebar__submenu-hr"></div>-->

      <div class="app-sidebar__submenu-logout">
        <div class="app-sidebar__submenu-logout-icon">
          <svg width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 8.99121L13 5.99121L10 2.99121M12 5.99121H6M6 11H2.66667C2.22464 11 1.80072 10.8829 1.48816 10.6746C1.17559 10.4662 1 10.1836 1 9.88889V2.11111C1 1.81643 1.17559 1.53381 1.48816 1.32544C1.80072 1.11706 2.22464 1 2.66667 1H6"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <a class="app-sidebar__submenu-logout-label" href="/index.php?r=site%2Flogout">Выход</a>
      </div>
    </div>

    <div
      class="app-sidebar__submenu app-sidebar__submenu_notifications"
      :class="{
        'app-sidebar__submenu_active': activeMenuItem === 'notifications',
      }"
    >
      <div class="app-sidebar__submenu-notifications-list">
        <div
          v-for="(item, index) in notifications.list"
          :key="index"
          class="app-sidebar__submenu-notifications-list-item"
        >
          <div class="app-sidebar__submenu-notifications-list-item-text" v-html="item.text">
            {{ item.text }}
          </div>
          <viewer
            v-if="item.files !== null"
            :images="notifications.images"
            class="app-sidebar__submenu-notifications-list-item-files"
          >
            <div
              v-for="(file, ind) in item.files"
              :key="ind"
              class="app-sidebar__submenu-notifications-list-item-files-file"
            >
              <img
                v-if="isImageExtension(file)"
                class="app-sidebar__submenu-notifications-list-item-files-file-image"
                :src="`images/${file}`"
              />
              <svg
                v-if="getFileExtension(file) === 'xls' || getFileExtension(file) === 'xlsx'"
                class="app-sidebar__submenu-notifications-list-item-files-file-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.47538 3.125H10.5823L8.05679 6.85381L10.9062 11H8.71957L6.98437 8.43767L5.24813 11H3.0625L5.91196 6.85381L3.38642 3.125H5.49336L6.98437 5.29456L8.47538 3.125Z"
                  fill="#12C971"
                />
                <path d="M1 13V1H13V13H1Z" stroke="#12C971" stroke-width="2" />
              </svg>
              <svg
                v-if="getFileExtension(file) === 'doc' || getFileExtension(file) === 'docx'"
                class="app-sidebar__submenu-notifications-list-item-files-file-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.8638 3.936L9.95481 10.2H7.54281L6.98481 5.70001L6.36381 10.2H4.00581L3.13281 3.936H4.98681L5.38281 8.859L6.04881 3.936H7.98381L8.54181 8.859L9.08181 3.936H10.8638Z"
                  fill="#2E6ECD"
                />
                <path d="M1 13V1H13V13H1Z" stroke="#2E6ECD" stroke-width="2" />
              </svg>
              <svg
                v-if="getFileExtension(file) === 'pdf'"
                class="app-sidebar__submenu-notifications-list-item-files-file-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 13V1H13V13H1Z" stroke="#E30000" stroke-width="2" />
                <path
                  d="M7.97945 6.09586C7.48199 6.49417 7.46615 6.50383 7.17242 6.75471C6.87868 7.00559 6.76904 7.04139 6.26922 7.43694M7.97945 6.09586C9.67803 5.44281 10.1319 3.99982 8.95455 3.57597C7.77722 3.15211 7.14923 4.57193 7.97945 6.09586ZM7.97945 6.09586C8.08468 6.71115 8.08899 6.70618 8.15772 7.10943C8.22778 7.52049 8.22428 7.5653 8.33318 8.17999M6.26922 7.43694C6.87557 7.65332 7.31484 7.81337 7.31484 7.81337C7.31484 7.81337 7.72812 7.96025 8.33318 8.17999M6.26922 7.43694C4.83359 6.34459 3.31108 6.68697 3.51918 7.88235C3.72729 9.07774 5.31607 8.8924 6.26922 7.43694ZM8.33318 8.17999C10.1597 8.26208 11.0773 9.48294 10.1081 10.2545C9.13889 11.026 8.06455 9.8819 8.33318 8.17999Z"
                  stroke="#E30000"
                />
              </svg>
              <svg
                v-if="isVideoExtension(file)"
                class="app-sidebar__submenu-notifications-list-item-files-file-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V2.33333C13 1.59695 12.403 1 11.6667 1Z"
                  stroke="#8E9CBB"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 7L5 4V10L10 7Z"
                  stroke="#8E9CBB"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg
                v-if="getFileExtension(file) === 'mp3' || getFileExtension(file) === 'mp4'"
                class="app-sidebar__submenu-notifications-list-item-files-file-icon"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8.5V4L10 5"
                  stroke="#8E9CBB"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 8.5C8 9.32843 7.32843 10 6.5 10C5.67157 10 5 9.32843 5 8.5C5 7.67157 5.67157 7 6.5 7C7.32843 7 8 7.67157 8 8.5Z"
                  stroke="#8E9CBB"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V2.33333C13 1.59695 12.403 1 11.6667 1Z"
                  stroke="#8E9CBB"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </viewer>
          <div class="app-sidebar__submenu-notifications-list-item-time">
            {{ item.created }}
          </div>
        </div>
      </div>
    </div>

    <div class="app-sidebar__mobilemenu" :class="{ 'app-sidebar__mobilemenu_active': mobileMenuActive }">
      <div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'calculations',
        }"
        @click="(e) => selectMenuItem(e, 'calculations')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Расчеты</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.calculations"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'calculations',
        }"
      >
        <a
          v-for="(item, itemIndex) in menuItemsLocal.calculations"
          :key="itemIndex"
          class="app-sidebar__mobilemenu-submenu-item"
          :class="{
            'app-sidebar__mobilemenu-submenu-item_disabled': !item.routeName && !item.route,
            'app-sidebar__mobilemenu-submenu-item_current': item.routeName && item.routeName === $route.name,
          }"
          :href="getMenuItemHref(item)"
          :target="isExternalMenuItem(item) ? '_blank' : null"
          :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
          @click="onSidebarMenuLinkClick($event, item)"
        >
          {{ item.label }}
        </a>
      </div>

      <div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'reports',
        }"
        @click="(e) => selectMenuItem(e, 'reports')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Отчеты</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.reports"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'reports',
        }"
      >
        <a
          v-for="(item, itemIndex) in menuItemsLocal.reports"
          :key="itemIndex"
          class="app-sidebar__mobilemenu-submenu-item"
          :class="{
            'app-sidebar__mobilemenu-submenu-item_disabled': !item.routeName && !item.route,
            'app-sidebar__mobilemenu-submenu-item_current': item.routeName && item.routeName === $route.name,
          }"
          :href="getMenuItemHref(item)"
          :target="isExternalMenuItem(item) ? '_blank' : null"
          :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
          @click="onSidebarMenuLinkClick($event, item)"
        >
          {{ item.label }}
        </a>
      </div>

      <div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'employees',
        }"
        @click="(e) => selectMenuItem(e, 'employees')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Кадры</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.employees"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'employees',
        }"
      >
        <a
          v-for="(item, itemIndex) in menuItemsLocal.employees"
          :key="itemIndex"
          class="app-sidebar__mobilemenu-submenu-item"
          :class="{
            'app-sidebar__mobilemenu-submenu-item_disabled': !item.routeName && !item.route,
            'app-sidebar__mobilemenu-submenu-item_current': item.routeName && item.routeName === $route.name,
          }"
          :href="getMenuItemHref(item)"
          :target="isExternalMenuItem(item) ? '_blank' : null"
          :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
          @click="onSidebarMenuLinkClick($event, item)"
        >
          {{ item.label }}
        </a>
      </div>

      <div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'references',
        }"
        @click="(e) => selectMenuItem(e, 'references')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Справочники</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.references"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'references',
        }"
      >
        <a
          v-for="(item, itemIndex) in menuItemsLocal.references"
          :key="itemIndex"
          class="app-sidebar__mobilemenu-submenu-item"
          :class="{
            'app-sidebar__mobilemenu-submenu-item_disabled': !item.routeName && !item.route,
            'app-sidebar__mobilemenu-submenu-item_current': item.routeName && item.routeName === $route.name,
          }"
          :href="getMenuItemHref(item)"
          :target="isExternalMenuItem(item) ? '_blank' : null"
          :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
          @click="onSidebarMenuLinkClick($event, item)"
        >
          {{ item.label }}
        </a>
      </div>

      <div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'allSections',
        }"
        @click="(e) => selectMenuItem(e, 'allSections')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Все разделы</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.allSections"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'allSections',
        }"
      >
        <div class="app-sidebar__submenu-list-all-sections">
          <div class="app-sidebar__submenu-list-all-sections-column">
            <div
              v-if="menuItemsLocal['allSections']['Отчеты'] && menuItemsLocal['allSections']['Отчеты'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">ОТЧЁТЫ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Отчеты']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="menuItemsLocal['allSections']['Кадры'] && menuItemsLocal['allSections']['Кадры'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">КАДРЫ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Кадры']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
          </div>
          <div class="app-sidebar__submenu-list-all-sections-column">
            <div v-if="userSectionNotEmpty" class="app-sidebar__submenu-list-all-sections-column-item">
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">ПОЛЬЗОВАТЕЛИ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Пользователи']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="menuItemsLocal['allSections']['Графики'] && menuItemsLocal['allSections']['Графики'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">ГРАФИКИ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Графики']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="menuItemsLocal['allSections']['Листовки'] && menuItemsLocal['allSections']['Листовки'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">ЛИСТОВКИ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Листовки']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="menuItemsLocal['allSections']['Маркетинг'] && menuItemsLocal['allSections']['Маркетинг'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">МАРКЕТИНГ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Маркетинг']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="menuItemsLocal['allSections']['Настройки'] && menuItemsLocal['allSections']['Настройки'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">НАСТРОЙКИ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Настройки']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="menuItemsLocal['allSections']['Расчеты'] && menuItemsLocal['allSections']['Расчеты'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">РАСЧЕТЫ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Расчеты']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
            <div
              v-if="
                menuItemsLocal['allSections']['Справочники'] && menuItemsLocal['allSections']['Справочники'].length > 0
              "
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <div class="app-sidebar__submenu-list-all-sections-column-item-title">СПРАВОЧНИКИ</div>
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Справочники']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-item"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
          </div>
          <div class="mt-2 app-sidebar__submenu-list-all-sections-column">
            <div
              v-if="menuItemsLocal['allSections']['Остальные'] && menuItemsLocal['allSections']['Остальные'].length > 0"
              class="app-sidebar__submenu-list-all-sections-column-item"
            >
              <a
                v-for="(item, itemIndex) in menuItemsLocal['allSections']['Остальные']"
                :key="itemIndex"
                class="app-sidebar__submenu-list-all-sections-column-item-title app-sidebar__submenu-list-all-sections-column-item-title-hover"
                style="cursor: pointer"
                :class="{
                  'app-sidebar__submenu-list-item_current': item.routeName && item.routeName === $route.name,
                }"
                :href="getMenuItemHref(item)"
                :target="isExternalMenuItem(item) ? '_blank' : null"
                :rel="isExternalMenuItem(item) ? 'noopener noreferrer' : null"
                @click="onSidebarMenuLinkClick($event, item)"
              >
                {{ item.label }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!--<div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'marketing',
        }"
        @click="(e) => selectMenuItem(e, 'marketing')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Маркетинг</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.marketing"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'marketing',
        }"
      >
        <div
          v-for="(item, itemIndex) in menuItemsLocal.marketing"
          :key="itemIndex"
          class="app-sidebar__mobilemenu-submenu-item"
          :class="{
            'app-sidebar__mobilemenu-submenu-item_disabled': !item.route,
            'app-sidebar__mobilemenu-submenu-item_current': item.route === $route.name,
          }"
          @click="goTo(item)"
        >
          {{ item.label }}
        </div>
      </div>-->

      <div
        class="app-sidebar__mobilemenu-item"
        :class="{
          'app-sidebar__mobilemenu-item_active': activeMenuItem === 'bookmarks',
        }"
        @click="(e) => selectMenuItem(e, 'bookmarks')"
      >
        <div class="app-sidebar__mobilemenu-item-label">Закладки</div>

        <div class="app-sidebar__mobilemenu-item-icon">
          <svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.70905 6.69036C6.32111 7.07811 5.69215 7.07811 5.30421 6.69036L0.306472 1.69499C-0.0814626 1.30723 -0.081462 0.678565 0.306473 0.290813C0.694408 -0.0969372 1.32337 -0.0969372 1.71131 0.290813L6.70905 5.28619C7.09698 5.67394 7.09698 6.30261 6.70905 6.69036Z"
            />
            <path
              d="M6.70905 5.29413C6.32111 4.90637 5.69215 4.90637 5.30421 5.29413L0.290951 10.305C-0.096984 10.6928 -0.0969834 11.3214 0.290951 11.7092C0.678886 12.0969 1.30785 12.0969 1.69579 11.7092L6.70905 6.6983C7.09698 6.31054 7.09698 5.68188 6.70905 5.29413Z"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="menuItemsLocal.bookmarks"
        class="app-sidebar__mobilemenu-submenu"
        :class="{
          'app-sidebar__mobilemenu-submenu_active': activeMenuItem === 'bookmarks',
        }"
      >
        <div
          v-for="(item, itemIndex) in menuItemsLocal.bookmarks"
          :key="itemIndex"
          class="app-sidebar__mobilemenu-submenu-item"
          :class="{
            'app-sidebar__mobilemenu-submenu-item_disabled': !item.route,
            'app-sidebar__mobilemenu-submenu-item_current': item.route === $route.name,
          }"
          @click="goTo(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import { IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from "../utils/files";

import Input from "@/components/controls/input";

Vue.use(VueCookies);

Vue.use(Viewer, {
  defaultOptions: {
    container: "#app",
    title: false,
    navbar: false,
    movable: false,
    zoomable: true,
    rotatable: false,
    scalable: false,
    next: false,
    prev: false,
    play: false,
  },
});

export default {
  name: "app-sidebar",

  components: {
    "c-input": Input,
  },

  data() {
    return {
      user: {
        avatar: "",
        name: "",
      },
      notifications: {
        count: 0,
        list: [],
        images: [],
      },
      activeMenuItem: null,
      menuItems: {},
      menuItemsLocal: {},
      search: "",
      findAllSectionsItems: [],
      collapsed: this.$cookies.get("mainMenuIsCollapsed") === "true",
      mobileMenuActive: false,
    };
  },

  computed: {
    userSectionNotEmpty() {
      return (
        this.menuItemsLocal.allSections["Пользователи"] && this.menuItemsLocal.allSections["Пользователи"].length > 0
      );
    },
  },

  watch: {
    collapsed(value) {
      this.$store.commit("app/setSidebarCollapsed", value);
      Vue.$cookies.set("mainMenuIsCollapsed", this.collapsed);

      setTimeout(() => {
        const evt = document.createEvent("UIEvents");
        evt.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(evt);
      }, 250);
    },

    search(value) {
      if (this.activeMenuItem === "allSections") {
        const allSectionsMenuItems = this.menuItems[this.activeMenuItem];
        const result = {};
        Object.keys(allSectionsMenuItems).forEach((key) => {
          result[key] = [];
          Object.keys(allSectionsMenuItems[key]).forEach((i) => {
            if (allSectionsMenuItems[key][i].label.toLowerCase().includes(value.toLowerCase())) {
              result[key].push(allSectionsMenuItems[key][i]);
            }
          });
        });
        this.menuItemsLocal[this.activeMenuItem] = result;
      } else {
        const menuItems = this.menuItems[this.activeMenuItem].filter((item) =>
          item.label.toLowerCase().includes(value.toLowerCase()),
        );

        this.menuItemsLocal[this.activeMenuItem] = menuItems;
      }
    },

    mobileMenuActive() {},
  },

  async created() {
    await this.$store.dispatch("app/getMenuList").then((res) => {
      this.user.name = res.response.user_info.name;
      this.user.avatar = res.response.user_info.photo;
      this.notifications.count = res.response.user_info.notifications_count;

      const mapKey = {
        Кадры: "employees",
        Расчеты: "calculations",
        Отчеты: "reports",
        Маркетинг: "marketing",
        Справочники: "references",
      };
      const items = {};

      Object.keys(res.response.sections).forEach((key) => {
        if (mapKey[key]) {
          items[mapKey[key]] = [];

          Object.keys(res.response.sections[key]).forEach((i) => {
            items[mapKey[key]].push({
              label: res.response.sections[key][i].label,
              route: res.response.sections[key][i].url,
              routeName: res.response.sections[key][i].routeName ? res.response.sections[key][i].routeName : "",
            });
          });
        }
      });

      // Все разделы
      items.allSections = {};
      Object.keys(res.response.sections).forEach((key) => {
        items.allSections[key] = [];

        Object.keys(res.response.sections[key]).forEach((i) => {
          items.allSections[key].push({
            label: res.response.sections[key][i].label,
            route: res.response.sections[key][i].url,
            routeName: res.response.sections[key][i].routeName ? res.response.sections[key][i].routeName : "",
          });
        });
      });

      this.menuItems = { ...items };
      this.menuItemsLocal = items;
    });

    await this.$store.dispatch("app/getUserNotificationsList").then((result) => {
      this.notifications.list = result.response.notifications.map((notification) => {
        if (notification.files !== null) {
          notification.files.forEach((file) => {
            if (
              this.getFileExtension(file) === "png" ||
              this.getFileExtension(file) === "jpg" ||
              this.getFileExtension(file) === "jpeg"
            ) {
              this.notifications.images.push(`images/${file}`);
            }
          });
        }
        return notification;
      });
    });

    this.setSidebarWidthVar();
  },

  mounted() {
    // const items = {};
    // for (let key of Object.keys(this.menuItems)) {
    //   items[key] = [];
    //
    //   for (let i in this.menuItems[key]) {
    //     items[key].push(this.menuItems[key][i]);
    //   }
    // }
    //
    // this.menuItemsLocal = items;
    // console.log(this.menuItemsLocal)
  },

  methods: {
    isImageExtension(file) {
      return IMAGE_EXTENSIONS.includes(this.getFileExtension(file));
    },
    isVideoExtension(file) {
      return VIDEO_EXTENSIONS.includes(this.getFileExtension(file));
    },
    isExternalMenuItem(item) {
      return Boolean(item.route) && !item.routeName && !String(item.route).includes("redesign#");
    },

    normalizeRedesignMenuUrl(route) {
      const origin = window.location.origin;
      const routeString = String(route);

      if (routeString.indexOf("/?r=redesign#") !== -1 || routeString.indexOf("?r=redesign#") !== -1) {
        if (routeString.startsWith("http://") || routeString.startsWith("https://")) {
          return routeString;
        }

        if (routeString.startsWith("/")) {
          return `${origin}${routeString}`;
        }

        return `${origin}/${routeString.replace(/^\//, "")}`;
      }

      // Сломанный URL после Url::to(): index.php?r=redesign%23%2Femployees%2F…
      const encodedRedesignMatch = routeString.match(/[?&]r=redesign(%23[^&]*)/i);
      if (encodedRedesignMatch) {
        const hashPart = decodeURIComponent(encodedRedesignMatch[1]);

        return `${origin}/?r=redesign${hashPart.indexOf("#") === 0 ? hashPart : `#${hashPart}`}`;
      }

      if (routeString.indexOf("redesign#") !== -1) {
        const hashIndex = routeString.indexOf("#");
        const hashPart = hashIndex >= 0 ? routeString.substring(hashIndex) : `#/${routeString.replace("redesign#", "")}`;

        return `${origin}/?r=redesign${hashPart}`;
      }

      return null;
    },

    getMenuItemHref(item) {
      const redesignEntry = `${window.location.origin}/?r=redesign`;
      const origin = window.location.origin;

      if (item.routeName) {
        const resolvedRoute = this.$router.resolve({ name: item.routeName });
        let href = `${redesignEntry}${resolvedRoute.href}`;

        if (item.route) {
          const normalizedRoute = this.normalizeRedesignMenuUrl(item.route);
          if (normalizedRoute && normalizedRoute.indexOf("?") !== -1 && href.indexOf("?") === -1) {
            href += normalizedRoute.substring(normalizedRoute.indexOf("?"));
          }
        }

        return href;
      }

      if (item.route) {
        const normalizedRoute = this.normalizeRedesignMenuUrl(item.route);
        if (normalizedRoute) {
          return normalizedRoute;
        }

        const route = String(item.route);
        if (route.startsWith("http://") || route.startsWith("https://")) {
          return route;
        }

        if (route.startsWith("/")) {
          return `${origin}${route}`;
        }

        return route;
      }

      return `${redesignEntry}#/`;
    },

    onSidebarMenuLinkClick(event, item) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
        this.activeMenuItem = null;
        return;
      }

      if (item.routeName) {
        event.preventDefault();
        this.$router.push({ name: item.routeName });
        this.activeMenuItem = null;
        this.mobileMenuActive = false;
        return;
      }

      if (this.isExternalMenuItem(item)) {
        event.preventDefault();
        const openedWindow = window.open(item.route, "_blank");
        if (openedWindow) {
          openedWindow.focus();
        }
        this.activeMenuItem = null;
        this.mobileMenuActive = false;
        return;
      }

      this.activeMenuItem = null;
    },

    selectMenuItem(e, value) {
      if (value === this.activeMenuItem) {
        this.activeMenuItem = null;
      } else if (value === "notifications" && this.notifications.list.length === 0) {
        this.activeMenuItem = null;
      } else {
        this.activeMenuItem = value;
      }

      if (value === "user" && this.mobileMenuActive) {
        this.mobileMenuActive = false;
        this.activeMenuItem = "user";
      }

      if (value === "notifications" && this.mobileMenuActive && this.notifications.list.length === 0) {
        this.mobileMenuActive = false;
        this.activeMenuItem = "user";
      }

      this.search = "";
    },

    goTo(item) {
      if (item.routeName.length > 0 || item.route) {
        this.activeMenuItem = null;
        if (item.routeName.length > 0) {
          this.$router.push({ name: item.routeName });
        } else {
          window.open(item.route, "_blank").focus();
        }
        this.mobileMenuActive = false;
      }
    },

    openMobileMenu() {
      this.mobileMenuActive = true;
      if (this.activeMenuItem === "user" || this.activeMenuItem === "notifications") {
        this.activeMenuItem = null;
      }
    },

    getFileExtension(fileName) {
      const parts = fileName.split(".");
      return parts[parts.length - 1];
    },

    setSidebarWidthVar() {
      document.documentElement.style.setProperty('--sidebar-width', `${this.$refs.sidebar.clientWidth}px`);
    },

    toggleCollapse() {
      this.collapsed = !this.collapsed;

      let interval = setInterval(() => {
        this.setSidebarWidthVar();
      }, 0);

      setTimeout(() => {
        clearInterval(interval)
      }, 300);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.app-sidebar {
  position: relative;

  &__overlay {
    position: absolute;
    width: calc(100vw - 200px);
    left: 200px;
    height: 100vh;
    z-index: 200;

    &_hidden {
      display: none;
    }

    @media screen and (max-width: 992px) {
      width: 100vw;
      left: 0;
    }
  }

  @media screen and (min-width: 993px) {
    &_collapsed {
      .app-sidebar__overlay {
        width: calc(100vw - 60px);
        left: 60px;
      }
    }
  }

  &__wrapper {
    padding: 12px 13px;
    position: relative;
    z-index: 450;
    background: $color-dark;
    height: 100vh;
    display: flex;
    flex-direction: column;
    transition: 0.2s;
    width: 200px;

    @media screen and (max-width: 992px) {
      width: 100vw;
      height: 50px;
      flex-direction: row;
      align-items: center;
      padding: 0 30px;
    }

    @media screen and (max-width: 700px) {
      padding: 0 20px;
    }

    @media screen and (min-width: 993px) {
      &_collapsed {
        width: 60px;

        .app-sidebar {
          &__user {
            &-name {
              visibility: hidden;
              opacity: 0;
            }
          }

          &__menu {
            &-item {
              &-label {
                visibility: hidden;
                opacity: 0;
              }
            }
          }
        }
      }
    }
  }

  &__header {
    padding: 12px 13px 10px;
    margin: -12px -13px;
    border-bottom: 1px solid $color-dark-border;

    @media screen and (max-width: 992px) {
      order: 3;
      display: flex;
      flex-direction: row-reverse;
      padding: 0;
      align-items: center;
      border-bottom: none;
      height: 50px;
    }
  }

  &__user {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 -13px;
    padding: 0 13px;
    overflow: hidden;

    @media screen and (max-width: 992px) {
      margin-right: 0;
    }

    @media screen and (max-width: 700px) {
      margin-right: 0;
    }

    &-avatar {
      width: 34px;
      height: 34px;
      flex-shrink: 0;
      border-radius: 50%;
      background: {
        size: cover;
        position: center;
      }
    }

    &-name {
      margin-left: 10px;
      color: $color-label;
      font-size: 13px;
      line-height: 14px;
      transition: 0.2s;

      @media screen and (max-width: 992px) {
        display: none;
      }
    }

    &_active {
      .app-sidebar__user-name {
        // color: $color-secondary;
      }
    }
  }

  &__notifications {
    width: 34px;
    height: 34px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    position: relative;

    &.app-sidebar__notifications__active {
      & svg path {
        stroke: $color-secondary;
      }
    }

    @media screen and (max-width: 992px) {
      margin-top: 0;
      margin-right: 15px;
    }

    &-count {
      position: absolute;
      background: $color-secondary;
      padding: 0 5px;
      font-size: 12px;
      line-height: 16px;
      border-radius: 8px;
      left: 18px;
      top: 0;
      font-weight: 500;
    }

    svg {
      margin-top: -1px;
    }
  }

  &__menu {
    margin-top: 12px;
    padding: 15px 0;
    flex-grow: 1;

    @media screen and (max-width: 992px) {
      order: 1;
      display: flex;
      padding: 0;
      margin-top: 0;
      height: 50px;
      margin-left: -6px;
    }

    @media screen and (max-width: 700px) {
      flex-grow: 0;
    }

    &-item {
      display: flex;
      align-items: center;
      cursor: pointer;

      & + .app-sidebar__menu-item {
        margin-top: 15px;

        @media screen and (max-width: 992px) {
          margin-top: 0;
        }
      }

      @media screen and (max-width: 992px) {
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }

      @media screen and (max-width: 700px) {
        display: none;

        &_mobile-menu {
          display: flex !important;
          position: relative;
          width: 34px;

          .app-sidebar__menu-item-icon {
            position: absolute;
            visibility: hidden;
            opacity: 0;
            transition: 0.2s;

            &_active {
              visibility: visible;
              opacity: 1;
            }
          }
        }
      }

      &-icon {
        width: 34px;
        height: 34px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          transition: 0.2s;
        }
      }

      &_calculations {
        svg {
          stroke: $color-label;
          fill: none;
        }
      }

      &_reports {
        svg {
          fill: $color-label;
        }
      }

      &_employees {
        svg {
          fill: $color-label;
        }
      }

      &_marketing {
        svg {
          fill: $color-label;
        }
      }

      &_bookmarks {
        svg {
          stroke: $color-label;
          fill: none;
        }
      }

      &_reference {
        svg {
          stroke: $color-label;
          fill: none;
        }
      }

      &_all_sections {
        svg {
          stroke: $color-label;
          fill: $color-label;
        }
      }

      &_mobile-menu {
        display: none;
      }

      &_active {
        .app-sidebar__menu-item {
          &-label {
            color: $color-secondary;
          }
        }

        &.app-sidebar__menu-item_calculations,
        &.app-sidebar__menu-item_bookmarks {
          svg {
            stroke: $color-secondary;
          }
        }

        &.app-sidebar__menu-item_reference {
          svg path {
            stroke: $color-secondary;
          }
        }

        &.app-sidebar__menu-item_reports,
        &.app-sidebar__menu-item_employees,
        &.app-sidebar__menu-item_all_sections,
        &.app-sidebar__menu-item_marketing {
          svg {
            fill: $color-secondary;
          }
        }
      }

      &-label {
        margin-left: 10px;
        color: $color-label;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 1px;
        transition: 0.2s;

        @media screen and (max-width: 992px) {
          display: none;
        }
      }
    }
  }

  &__submenu {
    width: 320px;
    position: absolute;
    top: 0;
    right: 0;
    height: 100vh;
    background: white;
    z-index: 400;
    transition: 0.3s;
    padding: 25px;

    &:after {
      position: absolute;
      content: "";
      width: calc(100% - 25px);
      height: 35px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
      left: 0;
      bottom: 25px;
    }

    &_all_sections {
      width: 670px;
    }

    @media screen and (max-width: 992px) {
      top: 0;
      right: 0 !important;
      width: 100vw;
      height: auto;
      visibility: hidden;
      opacity: 0;

      &_active {
        right: 0;
        visibility: visible;
        opacity: 1;
        top: 50px;
        width: 100vw;
      }
    }

    @media screen and (max-width: 700px) {
      display: none;
    }

    &_user {
      // overflow: hidden;
      // max-width: calc(100% - 30px);
      @media screen and (max-width: 992px) {
        display: block;
        height: auto;

        &:after {
          display: none;
        }
      }

      .app-sidebar__submenu-list {
        height: auto;
        padding-bottom: 0;
      }
    }

    &_notifications {
      @media screen and (max-width: 700px) {
        display: block !important;
      }
    }

    &-notifications-list {
      display: flex;
      flex-direction: column;
      overflow: auto;
      max-height: calc(100vh - 50px);

      @media screen and (max-width: 992px) {
        display: flex !important;
        height: auto;

        &:after {
          display: none;
        }
      }

      &_active {
        display: flex !important;
      }

      &-item {
        display: flex;
        flex-direction: column;
        padding-bottom: 8px;
        margin-bottom: 9px;
        border-bottom: solid 1px #dfe4ef;

        &:first-child {
          & .app-sidebar__submenu-notifications-list-item-text {
            margin-top: 0;
          }
        }

        &-text {
          font-size: 13px;
          line-height: 130%;
        }

        &-files {
          margin-top: 5px;
          display: flex;
          flex-wrap: wrap;

          &-file {
            position: relative;
            width: 55px;
            height: 50px;
            background: #ffffff;
            border: 1px solid #bfc9e0;
            box-sizing: border-box;
            border-radius: 3px;
            margin: 0 5px 5px 0;

            &-icon {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }

            &-image {
              cursor: pointer;
              object-fit: cover;
              width: 100%;
              height: 100%;
              border-radius: 3px;
            }
          }
        }

        &-time {
          margin-top: 5px;
          font-size: 12px;
          line-height: 130%;
          color: #8e9cbb;
        }
      }
    }

    &_all_sections_active {
      right: -670px;
      box-shadow: 0px 0px 20px rgba(8, 20, 45, 0.3);

      @media screen and (max-width: 992px) {
        right: 0;
        visibility: visible;
        opacity: 1;
        top: 50px;
        width: 100vw;
      }
    }

    &_active {
      right: -320px;
      box-shadow: 0px 0px 20px rgba(8, 20, 45, 0.3);
    }

    &-search {
      margin-bottom: 20px;
    }

    &-list {
      overflow-y: auto;
      height: calc(100% - 50px);
      padding-bottom: 25px;
      width: calc(100% + 10px);
      padding-right: 20px;

      &-all-sections {
        display: flex;
        overflow-y: auto;
        margin-left: -15px;
        height: calc(100% - 50px);
        width: calc(100% + 25px);

        @media screen and (max-width: 992px) {
          height: calc(100vh - 125px);
          width: calc(100% + 25px);
        }

        @media screen and (max-width: 700px) {
          margin-left: 0;
          flex-direction: column;
        }

        &::-webkit-scrollbar {
          width: 4px;
          height: 100%;
          background: white;
          cursor: pointer;
        }

        &::-webkit-scrollbar-thumb {
          background: $color-secondary;
          border-radius: 2px;
          cursor: pointer;
        }

        &::-webkit-scrollbar-track {
          background: $color-border-alt;
          width: 4px;
          border-radius: 2px;
          cursor: pointer;
        }

        &-column {
          width: calc((100% - 45px) / 3);
          margin-left: 15px;

          &:empty {
            display: none;
          }

          @media screen and (max-width: 700px) {
            width: 100%;
            margin-left: 0;
          }

          &-item {
            margin-bottom: 14px;

            &:last-child {
              padding-bottom: 25px;

              @media screen and (max-width: 700px) {
                padding-bottom: 0;
              }
            }

            @media screen and (max-width: 700px) {
              padding-bottom: 10px;
              margin-bottom: 8px;
            }

            &-title {
              display: block;
              text-transform: uppercase;
              font-size: 12px;
              font-weight: 700;
              letter-spacing: 1px;
              -moz-transition: all 0.2s ease-in;
              -o-transition: all 0.2s ease-in;
              -webkit-transition: all 0.2s ease-in;
              transition: all 0.2s ease-in;
              color: #333;
              margin-bottom: 6px;

              &-hover:hover {
                text-decoration: none;
                color: #000000;
              }
            }
          }
        }
      }

      @media screen and (max-width: 992px) {
        max-height: calc(100vh - 50px - 100px);
        height: auto;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &::-webkit-scrollbar {
        width: 4px;
        height: 100%;
        background: white;
        cursor: pointer;
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 2px;
        cursor: pointer;
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
        width: 4px;
        border-radius: 2px;
        cursor: pointer;
      }

      &-item {
        color: $color-primary;
        font-size: 13px;
        cursor: pointer;
        display: block;
        -moz-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;

        &:hover {
          color: #003f9d;
          text-decoration: none;
        }

        & + .app-sidebar__submenu-list-item {
          margin-top: 10px;
        }

        &_disabled {
          // color: $color-label;
          cursor: default;
        }

        &_current {
          color: $color-font;
        }
      }
    }

    &-hr {
      margin: 15px 0;
      height: 1px;
      width: 100%;
      background: $color-border-light;
    }

    &-logout {
      display: inline-flex;
      align-items: center;
      cursor: pointer;

      &-icon {
        svg {
          stroke: $color-label;
          fill: none;
        }
      }

      &-label {
        font-size: 13px;
        color: $color-primary;
        margin-left: 14px;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  &__settings {
    @media screen and (max-width: 992px) {
      order: 2;
      display: flex;
      height: 50px;
      align-items: center;
      margin-right: 30px;
    }

    @media screen and (max-width: 700px) {
      flex-grow: 1;
      margin-left: 10px;
    }

    &-item {
      margin-top: 10px;
      cursor: pointer;

      @media screen and (max-width: 992px) {
        margin-top: 0;
        margin-left: 10px;
      }

      &:first-child {
        margin-top: 0;
        margin-left: 0;
      }

      &_active {
        &.app-sidebar__settings-item {
          &_settings {
            svg {
              stroke: $color-secondary;
            }
          }

          &_help {
            svg {
              fill: $color-secondary;
            }
          }
        }
      }

      &-icon {
        width: 34px;
        height: 34px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          transition: 0.2s;
        }
      }

      &_settings {
        svg {
          stroke: $color-label;
          fill: none;
        }
      }

      &_help {
        svg {
          fill: $color-label;
        }
      }
    }
  }

  &__collapse {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid $color-label;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    cursor: pointer;
    margin-top: 30px;
    transform: rotate(180deg);

    @media screen and (max-width: 992px) {
      display: none;
    }

    &-icon {
      svg {
        margin-top: -1px;
      }
    }

    &_collapsed {
      transform: none;
    }
  }

  &__mobilemenu {
    display: none;

    @media screen and (max-width: 700px) {
      display: block;
      position: absolute;
      width: 100vw;
      height: calc(100vh - 50px);
      overflow-y: auto;
      top: 50px;
      left: -100vw;
      background: $color-dark;
      z-index: 200;
      border-top: 1px solid $color-dark-border;
      transition: 0.3s;

      &_active {
        left: 0;
      }

      &-submenu {
        background: white;
        height: 0;
        overflow: hidden;
        padding: 0 20px;
        transition: 0.2s;

        &_active {
          height: auto;
          padding: 20px;
        }

        &-item {
          color: $color-primary;
          font-size: 13px;
          cursor: pointer;

          & + .app-sidebar__mobilemenu-submenu-item {
            margin-top: 10px;
          }

          &_disabled {
            // color: $color-label;
            cursor: default;
          }

          &_current {
            color: $color-font;
          }
        }
      }

      &-item {
        border-bottom: 1px solid $color-dark-border;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        height: 50px;
        align-items: center;

        &-label {
          color: $color-label;
          text-transform: uppercase;
          font-weight: 700;
          letter-spacing: 1px;
          font-size: 15px;
          transition: 0.2s;
        }

        &-icon {
          transition: 0.2s;
          svg {
            fill: $color-label;
          }
        }

        &_active {
          .app-sidebar__mobilemenu-item-label {
            color: $color-secondary;
          }

          .app-sidebar__mobilemenu-item-icon {
            transform: rotate(90deg);

            svg {
              fill: $color-secondary;
            }
          }
        }
      }
    }
  }
}

::v-deep .viewer-backdrop {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
</style>
